import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { Button } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { useSelector, useDispatch } from 'react-redux';
import PanierService from "../../services/PanierService";
import Badge from 'react-bootstrap/Badge';
import { logoutRequest } from "../../backend/auth/logout";
import { resetAuthData } from "../../app/providers/authSlice";
import { resetCart } from "../../app/providers/panierSlice";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';



import Swal from "sweetalert2";


export default function Header() {
    const location = useLocation();
    const pathname = location.pathname;
    const auth = useSelector(state => state.auth)
    const test = useSelector((state) => state.panier.countPanier);
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const nbrePublication = localStorage.getItem('nbrePanier');

       //recherche par titre

       const [searchTerm, setSearchTerm] = useState('');

       const navigate = useNavigate();


    const updatePanier = async () => {
        //console.log("################## test panier ###############")
        try {
            await PanierService.index().then(({ data }) => {
               // console.log(data)
            }).catch(({ response }) => {
               // console.log(response)
            });
        } catch (error) {
            console.log(error);
        }
    }

    // se déconnecter
	const handleLogout = () => {    
		logoutRequest(auth.token);
		dispatch(resetAuthData());
        dispatch(resetCart());
        Swal.fire({
            icon: "success",
                    title: 'Vous vous êtes déconnectée avec succès',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    background: "green",
                    color: "white",
                    iconColor: "white"
          });
	}


    useEffect(() => {
        updatePanier();
    }, []);

    //Fontion pour prendre le thème de recherche et le renvoyer sur la page de résultats
    const handleSearch = (e) => {
        e.preventDefault();
        navigate(`/publications/recherche_par_titre/${searchTerm}`)
        window.location.reload();
    };


    return (
        <React.Fragment>
            {/** Navbar Start */}
    <div className="container-fluid position-relative p-0">
         <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
        
            <Link to={ myroutes.homepage } className="navbar-brand  p-0">
             <h1 className="text-primary m-0" style={{fontWeight: "500", fontSize:"26px" }}><img src="../startup/img/logo-digiweb2.png" alt="logo-blanc" style={{height: "65px" }}/> DGBOOK</h1>
            </Link>

             <button className="navbar-toggler1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
              <span className="fa fa-bars"></span>
               </button>
              <div className="collapse navbar-collapse" id="navbarCollapse">
                <div className="navbar-nav ms-auto py-0">

                <Link
              to={myroutes.homepage} className={`nav-item nav-link ${pathname === myroutes.homepage ? "active" : ""}`} >
              Accueil
            </Link>
            <Link
              to={myroutes.catalogue} className={`nav-item nav-link ${pathname === myroutes.catalogue ? "active" : ""}`} >
              Catalogue
            </Link>
            <Link  to={myroutes.comment_ca_marche} className={`nav-item nav-link ${ pathname === myroutes.comment_ca_marche ? "active" : ""}`}>
              Comment ça marche ?
            </Link>
            <Link to={myroutes.contact} className={`nav-item nav-link ${pathname === myroutes.contact ? "active" : "" }`} >
              Contact
            </Link>
              </div>
              {auth.isAuthenticate ? 
                            ( 
                            <>
                         <div className="d-flex align-items-center d-lg-none d-xl-none"> {/* Conteneur parent avec alignement en ligne */}

                             {auth.roles.includes("USER") && auth.roles.includes("ADMIN") ? (
                                // Si l'utilisateur a les deux rôles ("USER" et "ADMIN")
                                <>
                                <DropdownButton variant="outline-warning" style={{zIndex: 999999}} className="bouton me-3 d-lg-none d-xl-none" id="dropdown-basic-button" title="Mon compte">
                                <Dropdown.Item href={myroutes.dashboard}><i className="fa fa-th-large me-2"></i>Tableau de bord</Dropdown.Item>
                                <Dropdown.Item href={myroutes.moncompte}><i className="fa fa-th-large me-2"></i>Mon compte utilisateur</Dropdown.Item>
                                </DropdownButton>
                                    
                                </>
                            ) : auth.roles.includes("USER") ? (

                                // Si l'utilisateur a uniquement le rôle "USER"
                                <Link to={myroutes.moncompte}>
                                    <Button variant="outline-warning" className="bouton me-3">
                                        <i className="fa fa-th-large me-2"></i>Mon compte
                                    </Button>
                                </Link>
                            ) : (
                                // Si l'utilisateur a uniquement le rôle "ADMIN" 
                                <Link to={myroutes.dashboard}>
                                    <Button variant="outline-warning" className="bouton me-3">
                                        <i className="fa fa-th-large me-2"></i>Tableau de bord
                                    </Button>
                                </Link>
                            )}
                                <Button
                                    variant="warning"
                                    onClick={handleLogout}
                                >
                                    <i className="fa fa-stop me-2 "></i>Se déconnecter
                                </Button>
                                </div>
                            </>
                        ) : (
                            <>
                            <Button  className="btn  bg-warning me-3  d-lg-none d-xl-none" onClick={handleShow}><i className="fa fa-user-plus me-2"></i>S'inscrire</Button>
                            <Link to={myroutes.login}  className="btn  bg-primary d-lg-none d-xl-none" style={{color:"white"}}><i className="fa fa-lock me-2 "></i>Se connecter</Link>

                            </>
                        )}

                        <Button type="button" className="btn  bg-primary text-white ms-3" data-bs-toggle="modal" data-bs-target="#searchModal"><i className="fa fa-search" ></i></Button>
                        <Link to={myroutes.monpanier} title="voir le panier pour plus de détails" className="btn btn-primary py-2 px-4 m-4 ms-3"> <i className="fas fa-shopping-cart me-2"></i> Panier <Badge bg="white text-black">{test}</Badge></Link>

            </div>
        </nav>

        <Modal show={show} onHide={handleClose} centered className="custom-modal">
                <Modal.Header closeButton>
                   
                    <Modal.Title className="mx-auto me-3"> Type d'utilisateur</Modal.Title>
                    
                </Modal.Header>
            
                <Modal.Body>
                <Container>
        
          <Row>
            <Col xs={8} md={6}>
            <Button href="/register" variant="primary" style={{ padding:"22px", borderRadius:"4px", marginBottom:"10px" }}>Je suis un particulier</Button>{' '}
            </Col>
            <Col xs={8} md={6}>
            <Button href="/register_entreprise" variant="warning" style={{ padding:"22px", borderRadius:"4px"  }}>Je suis une entreprise</Button>{' '}
               </Col>
          </Row>
        </Container>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="dark" onClick={handleClose} className="mx-auto">
                Fermer
                </Button>
            </Modal.Footer>
                </Modal>

       
    </div>
    {/** Navbar End */}


    {/** Full Screen Search Start */}
    <div className="modal fade" id="searchModal" tabIndex="-1">
        <div className="modal-dialog modal-fullscreen">
            <div className="modal-content" style={{ background:"rgba(9, 30, 62, .7)" }} >
                <div className="modal-header border-0">
                    <button type="button" className="btn bg-white btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body d-flex align-items-center justify-content-center">
                    <div className="input-group" style={{ maxWidth:"600px" }}>
                    <InputGroup className="mb-3">
                                <Form.Control
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Rechercher par titre"
                                />
                                <Button variant="outline-light" id="button-addon1" onClick={handleSearch}>
                                <i className="bi bi-search"></i>
                                </Button>

                            </InputGroup>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/** Full Screen Search End */}
        </React.Fragment>
    )
}